import React from 'react'
import CloseIcon from '@material-ui/icons/Close'

import MUIIcon from '../mui-icon'

export default function ModalHeader ({
  children,
  id = null,
  onClose,
}) {
  return (
    <header>
      <h1 className="header-content" id={id}>
        { children }
      </h1>
      {onClose && <div className="header-close-action">
        <MUIIcon
          color="grey"
          onClick={onClose}
          component={CloseIcon}
          tabIndex="0"
        />
      </div>}
    </header>
  )
}
